import { Reveal } from "./Reveal";
import { VALUES, CLIENTS } from "../../data";

export const Founder = () => {
  return (
    <section id="founder" data-testid="founder" className="relative py-28 lg:py-40 border-t border-hairline bg-surface/20">
      <div className="mx-auto max-w-[1500px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-16">
          {/* Founder */}
          <div className="lg:col-span-5">
            <Reveal>
              <span className="font-mono text-xs tracking-[0.3em] uppercase text-gold">Founder</span>
              <div className="mt-8 relative border border-hairline bg-ink aspect-[4/5] max-w-sm overflow-hidden group">
                <img
                  src="/founder-erez.jpeg"
                  alt="Erez Hevroni, Founder & CEO of EQ Capital Group"
                  className="absolute inset-0 h-full w-full object-cover object-top grayscale group-hover:grayscale-0 transition-[filter] duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6 border-t border-hairline bg-ink/60 backdrop-blur-sm">
                  <p className="font-serif text-2xl text-parchment">Erez Hevroni</p>
                  <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-gold mt-1">Founder &amp; CEO</p>
                </div>
              </div>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="font-mono text-[11px] tracking-[0.15em] uppercase text-stone mt-6 leading-relaxed">
                Investment Banker · Capital Advisor · Investor Relations · Family Office Advisor · Executive Coach
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <p className="text-stone text-lg leading-relaxed">
                Erez Hevroni brings a rare combination of Wall Street experience, capital markets expertise, investor relations leadership and emotional intelligence coaching. He has advised founders, institutional investors, family offices and ultra-high-net-worth individuals — helping companies raise over <span className="text-gold">$500 million</span> across multiple industries.
              </p>
              <p className="font-serif italic text-2xl sm:text-3xl text-parchment/90 mt-8 leading-snug">
                "The greatest investment you will ever make is in the quality of your relationships."
              </p>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="mt-12 border-t border-hairline pt-10">
                <span className="font-mono text-xs tracking-[0.3em] uppercase text-gold">Core Values</span>
                <div className="grid sm:grid-cols-2 gap-x-10 gap-y-6 mt-6">
                  {VALUES.map((v) => (
                    <div key={v.t} className="border-l border-hairline pl-4 hover:border-gold transition-colors duration-300">
                      <p className="font-serif text-xl text-parchment">{v.t}</p>
                      <p className="text-stone text-sm mt-1">{v.d}</p>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          </div>
        </div>

        {/* Who We Work With */}
        <Reveal delay={0.1}>
          <div className="mt-20 border-t border-hairline pt-14">
            <span className="font-mono text-xs tracking-[0.3em] uppercase text-gold">Who We Work With</span>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
              {CLIENTS.map((c, i) => (
                <Reveal key={c.title} delay={i * 0.08}>
                  <div className="border border-hairline p-8 h-full hover:border-gold/50 hover:bg-ink transition-colors duration-500">
                    <p className="font-serif text-2xl text-parchment">{c.title}</p>
                    <p className="text-stone text-sm leading-relaxed mt-3">{c.body}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
